module.exports = __webpack_public_path__ + "static/media/ic-v-badge-en.797a1d43.png";